/* istanbul ignore file: this file does not contain any logic, only factory calls */ import { createRequestFactory, BaseOptions } from "@devowl-wp/utils";
// Only needed once per `window`
let FACTORY_MEMO;
function get() {
    return FACTORY_MEMO ? FACTORY_MEMO : FACTORY_MEMO = createRequestFactory(window[BaseOptions.getPureSlug(process.env.slug, true)]);
}
const urlBuilder = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return get().urlBuilder(...args);
};
const request = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return get().request(...args);
};
export { urlBuilder, request };
